(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }
  
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.announcementBar = document.querySelector('.announcement-bar-section');
      this.headerBounds = {};
  
      window.requestAnimationFrame(this.setHeaderHeight.bind(this));
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      window.addEventListener('resize', this.setHeaderHeight.bind(this));
  
      this.currentScrollTop = 0;
      this.onScrollHandler = this.onScroll.bind(this);
  
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }
  
    setHeaderHeight() {
      const announcementHeight = this.announcementBar ? this.announcementBar.offsetHeight : 0;

      if (this.announcementBar) {
        this.announcementBar.style.zIndex = '101';
      }
      
      this.header.style.top = `${announcementHeight}px`;
      this.header.style.position = 'sticky';
      this.header.style.zIndex = '100';
  
      const totalHeaderHeight = this.header.offsetHeight;
      document.documentElement.style.setProperty('--current-headers-height', `${totalHeaderHeight}px`);
      document.documentElement.style.setProperty('--current-announcement-height', `${announcementHeight}px`);
    }
  
    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.setHeaderHeight);
    }
  
    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }
  
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const threshold = this.headerBounds.bottom || this.header.offsetHeight || 50;
  
      if (scrollTop > threshold) {
        this.header.classList.add('scrolled-past-header', 'shopify-section-header-sticky');
      } else {
        this.header.classList.remove('scrolled-past-header', 'shopify-section-header-sticky');
      }
  
      this.currentScrollTop = scrollTop;
    }
  
    hide() {}
  
    reveal() {
      this.header.classList.add('shopify-section-header-sticky');
    }
  
    reset() {
      this.header.classList.remove('shopify-section-header-sticky');
    }
  }
  
  customElements.define('sticky-header', StickyHeader);
  
  } catch(e) { console.error(e); }
})();
})();
